import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: center;
  height: 100%;
  width: 100%;
  div[data-test-id="bar-chart-test-id"] {
    max-width: 400px;
    width: 100%;
  }
  ${mediaMaxWidth.phone} {
    div[data-test-id="bar-chart-test-id"] {
      max-width: 100%;
    }
  }
`;

interface IPlaceholderProps {
  hidden?: boolean;
}

export const Placeholder = styled.div`
  display: ${(props: IPlaceholderProps) => (props.hidden ? "hidden" : "flex")};
  flex: 1;
  justify-content: center;
  align-items: center;
`;
